<template>
  <div class="form-group dropify-context" v-if="render">
    <label :title="tooltip(element.label)">
      {{ t(element.label) }}
      <icons-render :propIcons="element.icons"/>
    </label>
    <input
      :name="element.name"
      :type="type"
      :readonly="element.readonly"
      @change="_change"
      class="form-control"
      ref="file"
    />
    <div v-if="showPreloader" class="preloader-wrapper preloader-wrapper__dropify">
      <div class="loader loader-grill"></div>
    </div>
    <div v-if="fileSize" class="dropify-file-size">Velikost souboru: {{ fileSize }} KB</div>
  </div>
</template>

<script>
import FileLoader       from '../../../model/loader/file-loader'
import IconsRender      from '../../templates/widgets/icons-render'
import imageCompression from 'browser-image-compression'
import DictionaryLoader         from '@/model/loader/dictionary-loader'

export default {
  name:       'FileUpload',
  components: {
    IconsRender
  },
  props:      {
    element: {
      required: true,
      type:     Object,
      default:  () => {
        return {
          name:     null,
          type:     null,
          dataType: null,
          label:    null
        }
      }
    }
  },

  data () {
    return {
      type:          'file',
      file:          null,
      initDropify:   undefined,
      fileSize:      null,
      showPreloader: false,
      render:        true
    }
  },

  created () {

    this.initDropify = (defaultFileSrc = null, fileName = null) => {
      let options = {
        maxFileSize: '10M',
        tpl:         {
          filename:    '',
          clearButton: ''
        }
      }

      if (defaultFileSrc) {
        options['defaultFile'] = defaultFileSrc
      }

      if (fileName) {
        options.tpl.filename = fileName
      }

      return $(this.$refs.file).dropify(options)
    }
  },

  methods: {

    /**
     *
     * @param value
     */
    updateValue (value) {
      value = value.value

      this.file = value

      if (!this.file) {
        this.initDropify()

        return
      }

      FileLoader
        .sizeType('L')
        .get(this.file)
        .then((response) => {
          let src      = 'data:image/jpeg;base64,' + response.data.fileContents,
              // fileName = response.data.fileDownloadName
              fileName = 'preview-image'

          this.initDropify(src, encodeURIComponent(fileName))
        })
    },

    /**
     *
     * @param values
     * @param fieldName
     */
    updateHighlighters (values, fieldName) {
      this.element.icons.forEach((icon) => {
        if (icon.def.ColumnName === fieldName) {
          icon.value = JSON.parse(values.value)
        }
      })
    },

    /**
     *
     * @param e Event
     * @private
     */
    _change (e) {
      this.showPreloader = true

      let file   = e.target.files[0],
          reader = new FileReader()

      const options            = {
              maxSizeMB:        2,
              maxWidthOrHeight: 2048
            },
            acceptedImageTypes = [
              'image/gif',
              'image/jpeg',
              'image/png'
            ],
            processFile        = (file) => {
              reader.readAsDataURL(file)

              reader.onload = () => {
                this.file = {
                  // name:       file.name,
                  // size:       file.size,
                  // type:       file.type,
                  // base64Data: reader.result
                }

                this.file[this.element.document.dataKey.toUpperCase()]      = reader.result
                this.file[this.element.document.dataFileName.toUpperCase()] = file.name

                const fileSizeInKB = file.size / 1024
                // this.fileSize      = fileSizeInKB.toFixed(3)
                this.fileSize      = Math.round(fileSizeInKB)

                this.showPreloader = false

                this.$emit('changeValue', { element: this.element, value: this.file })
              }
            }

      if (acceptedImageTypes.includes(file.type)) {
        imageCompression(file, options).then((processedFile) => {
          processFile(processedFile)
        })

        return
      }

      processFile(file)
    },

    setRender (render) {
      this.render = render
    },

    tooltip (key) {
      return DictionaryLoader.tooltip(key, this.$user.languageCode)
    }

  }
}
</script>

<style scoped>
.dropify-file-size {
  font-size: 12px;
}

</style>
